import type React from "react";
import {Handle, type NodeProps, Position} from "@xyflow/react";
import {Stack, Typography} from "@mui/material";
import type {StubNode} from "~/pages/supplier-360/tabs/SupplierValueChain/components/chain/valueChainLayout";

const HIDDEN_HANDLE: React.CSSProperties = {opacity: 0, pointerEvents: 'none'};

/** The placeholder for a side of the chain with no links. */
export const ChainStubNode: React.FC<NodeProps<StubNode>> = ({data}) => {
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
                height: '100%',
                border: '1px dashed',
                borderColor: 'grey.300',
                borderRadius: '12px',
                bgcolor: 'grey.50',
            }}
        >
            <Handle type="target" position={Position.Left} isConnectable={false} style={HIDDEN_HANDLE}/>
            <Typography variant="caption" fontWeight={600} color="text.secondary">
                {data.label}
            </Typography>
            <Handle type="source" position={Position.Right} isConnectable={false} style={HIDDEN_HANDLE}/>
        </Stack>
    );
};
